import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createSaleOrdEntry = createAsyncThunk('createSaleOrdEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSaleOrder`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateSaleOrder = createAsyncThunk('updateSaleOrder', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateSaleOrder`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertSOrateQuotation = createAsyncThunk('insertSOrateQuotation', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSOrateQuotation`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertSOquotwise = createAsyncThunk('insertSOquotwise', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=InsertSOQuotationWise`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOQuotationlist = createAsyncThunk('fetchSOQuotationlist', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOQuotationlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const getQuotationEntryNo = createAsyncThunk('getQuotationEntryNo', async () => {
    // const { firmId, partyId } = postData;
    try {
        // const endpoint = postData && firmId && partyId ? `getQuotationEntryNo&firmId=${firmId}&partyId=${partyId}` : `getQuotationEntryNo`;
        const response = await axios.get(`${baseUrl}?apicall=getQuotationEntryNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleOrder = createAsyncThunk('fetchSaleOrder', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSaleOrderlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const getPartyList = createAsyncThunk('getPartyList', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartyAsperSOFirm&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleBarcode = createAsyncThunk('fetchSaleBarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSoBarcode`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOno = createAsyncThunk('fetchSOno', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOno`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSORegister = createAsyncThunk('fetchSORegister', async (id) => {
    try {
        const endpoint = id ? `getSOlist&soId=${id}` : 'getSOlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSORegister2 = createAsyncThunk('fetchSORegister2', async (id) => {
    try {
        const endpoint = id ? `getSOlist&sono=${id}` : 'getSOlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOinfolist = createAsyncThunk('fetchSOinfolist', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOinfolist&soId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchSOMaterialList = createAsyncThunk('fetchSOMaterialList', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOMaterialList&soId=${id}`);
        console.log("api response=>", response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSOnoInfolist = createAsyncThunk('fetchSOnoInfolist', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSOinfolist&sono=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteSingleSaleOrd = createAsyncThunk('deleteSingleSaleOrd', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteSaleOrder&sono=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const saleOrderSlice = createSlice({
    name: 'SaleOrderData',
    initialState: {
        isLoading: false,
        saleorder: null,
        barcode: null,
        deleteSale: null,
        sono: null,
        soquot: null,
        qtEntry: null,
        partylist: null,
        solist: null,
        soinfo: null,
        sonolist: null,
        soMaterialList: {        // ✅ ADD THIS
            data: [],
            infoData: {}
        },
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSaleOrder.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.saleorder = action.payload;
        });
        builder.addCase(fetchSaleOrder.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSaleBarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleBarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.barcode = action.payload;
        });
        builder.addCase(fetchSaleBarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSOno.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOno.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sono = action.payload;
        });
        builder.addCase(fetchSOno.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(deleteSingleSaleOrd.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleSaleOrd.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteSale = action.payload;
        });
        builder.addCase(deleteSingleSaleOrd.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSOQuotationlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOQuotationlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.soquot = action.payload;
        });
        builder.addCase(fetchSOQuotationlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
        builder.addCase(fetchSOMaterialList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchSOMaterialList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.soMaterialList = action.payload; // ✅ VERY IMPORTANT
        });

        builder.addCase(fetchSOMaterialList.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Error", action.error.message);
        });


        builder.addCase(getQuotationEntryNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getQuotationEntryNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.qtEntry = action.payload;
        });
        builder.addCase(getQuotationEntryNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(getPartyList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getPartyList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.partylist = action.payload;
        });
        builder.addCase(getPartyList.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSORegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSORegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.solist = action.payload;
        });
        builder.addCase(fetchSORegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSOinfolist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOinfolist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.soinfo = action.payload;
        });
        builder.addCase(fetchSOinfolist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSOnoInfolist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSOnoInfolist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sonolist = action.payload;
        });
        builder.addCase(fetchSOnoInfolist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSORegister2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSORegister2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.solist = action.payload;
        });
        builder.addCase(fetchSORegister2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default saleOrderSlice.reducer;
